import PropTypes from "prop-types";
import { statusClasses } from "utils/formatters";

export default function Badge({ status, className }) {
  return (
    <span className={`rounded-full px-2 py-1 text-xs font-semibold ${statusClasses(status)} ${className}`}>{status?.toUpperCase()}</span>
  );
}

Badge.propTypes = {
  status: PropTypes.string.isRequired,
};
